import { buildIndustriesServedDisplay, type MissionHeatmapIndustryInput, type MissionHeatmapProjectionInput } from "./missionHeatmapDisplay";

export type ProfileIndustriesServedCardLabels = Readonly<{
  title: string;
  countLabel: string;
  emptyLabel: string;
  editAriaLabel?: string;
}>;

export type ProfileIndustriesServedCardProps = Readonly<{
  className?: string;
  componentInstance?: string;
  industries?: readonly MissionHeatmapIndustryInput[];
  labels: ProfileIndustriesServedCardLabels;
  onEdit?: () => void;
  projection?: MissionHeatmapProjectionInput;
}>;

function IndustriesServedEditIcon({ className }: Readonly<{ className?: string }>) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4 11.5-11.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ProfileIndustriesServedCard({
  className,
  componentInstance = "profileIndustriesServedCard",
  industries,
  labels,
  onEdit,
  projection,
}: ProfileIndustriesServedCardProps) {
  const display = buildIndustriesServedDisplay(projection, industries);

  return (
    <section
      className={["profile-industries-served-card", className].filter(Boolean).join(" ")}
      data-component-instance={componentInstance}
      data-industries-served-count={String(display.count)}
    >
      <div className="profile-industries-served-card__header profile-section-header">
        <div className="profile-section-header__title-group">
          <h2>{labels.title}</h2>
          {onEdit && labels.editAriaLabel ? (
            <button
              type="button"
              className="profile-industries-served-card__edit-button"
              aria-label={labels.editAriaLabel}
              data-component-instance={`${componentInstance}EditButton`}
              onClick={onEdit}
            >
              <IndustriesServedEditIcon className="profile-industries-served-card__header-icon" />
            </button>
          ) : null}
        </div>
        <div
          className="profile-industries-served-card__metric"
          aria-label={`${display.count} ${labels.countLabel}`}
        >
          <strong className="profile-industries-served-card__count">{display.count}</strong>
          <span className="profile-industries-served-card__count-label">{labels.countLabel}</span>
        </div>
      </div>

      {display.count > 0 ? (
        <p className="profile-industries-served-card__list">{display.industryListLabel}</p>
      ) : (
        <p className="profile-industries-served-card__empty">{labels.emptyLabel}</p>
      )}
    </section>
  );
}
